'use strict';

exports.__esModule = true;

var _LocationUtils = require('history/LocationUtils');

Object.defineProperty(exports, 'createLocation', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.createLocation;
  }
});
Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-history/LocationUtils.js
 ** module id = 607
 ** module chunks = 0
 **/